import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import { CiEdit } from "react-icons/ci";

import api from "../../services/api";
import "react-toastify/dist/ReactToastify.css";

import { isAdmin } from "../../services/auth";

import "./enfermeiro.scss";
import { useExcluirEnfermeiros } from "../utils/excluir"
import Tooltip from "@mui/material/Tooltip";
import { MdDeleteForever } from "react-icons/md";

import Swal from "sweetalert2";
import Preloader from "../PreloaderGrids/Preloader";

import logo from "../../assets/logo.png"



import { FiFileText, FiSearch, FiX, FiChevronLeft, FiChevronRight, FiUserPlus, FiPlus } from "react-icons/fi";









function Enfermeiros() {
  const [marc, setMot] = useState([]);
  const [marcadores, setMarcadores] = useState([]);
  const [pages, setPages] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [mediaPage, setMediaPage] = useState(2);
  const [limit, setLimit] = useState(50);
  const [searchTerm, setSearchTerm] = useState("");
  const colorPagination = "#dee2e6";
  const tipo = localStorage.getItem("tipo");
  const [selecionados, setSelecionados] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [isAdminState, setIsAdminState] = useState(false);
  // const [selectedIds, setSelectedIds] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  //TITULO TABELA
  const titulo_tabela = "Enfermeiros"
  //NAVEGAÇÃO 
  const navigate = useNavigate();

  const [loadingPage, setLoadingPage] = useState(false);
  const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
  const [loading, setLoading] = useState(true);
  const [showLoader, setShowLoader] = useState(true);













  useEffect(() => {
    const checkAdmin = async () => {
      const response = await isAdmin();
      if (response.status === "success" && response.isAdmin) {
        setIsAdminState(true);
      } else {
        setIsAdminState(false);
      }
    };

    checkAdmin();
  }, []);










  useEffect(() => {
    async function fetchTotalPages() {
      try {
        const { data } = await api.get(`/totalenfermeiro?searchTerm=${encodeURIComponent(searchTerm.trim())}`, {
          headers: {
            typo: localStorage.getItem("id"),
          },
        });

        const total = data.result;
        setTotalItems(total);

        const totalPages = Math.ceil(total / limit);
        const arrayPages = Array.from({ length: totalPages }, (_, i) => i + 1);
        setPages(arrayPages);

        if (currentPage > totalPages) {
          setCurrentPage(1);
          setMediaPage(2);
        }
      } catch (error) {
        console.error("Erro ao buscar total de enfermeiros:", error);
      }
    }

    fetchTotalPages();
  }, [limit, searchTerm]);

  //===================================
  //PAGINAÇÃO
  //===================================
  const handlePagination = async (page) => {
    if (page === currentPage) return;

    if (page >= 1 && page <= pages.length) {
      try {
        setLoadingPage(true);

        setCurrentPage(page);

        if (page === 1) {
          setMediaPage(2);
        } else if (page === pages.length) {
          setMediaPage(page - 1);
        } else {
          setMediaPage(page);
        }

        // pequeno delay para renderizar
        await new Promise(resolve => setTimeout(resolve, 100));

      } finally {
        setLoadingPage(false);
      }
    }
  };



  //CONFIRMAÇÃO PDF
  const confirmarPDF = async () => {
    // =========================================================
    // VALIDAR REGISTROS
    // =========================================================

    if (!marcadores || marcadores.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Nenhum registro",
        text: "Não há enfermeiros para gerar o PDF.",
        background: "#0f172a",
        color: "#fff",
        confirmButtonColor: "#f59e0b",
      });

      return;
    }

    // =========================================================
    // REGISTROS QUE SERÃO ENVIADOS PARA O PDF
    // =========================================================

    const enfermeirosPDF = marcadores;

    console.log("=================================");
    console.log("GERAÇÃO DE PDF");
    console.log("Enfermeiros:", enfermeirosPDF);
    console.log("Quantidade:", enfermeirosPDF.length);
    console.log("=================================");

    // =========================================================
    // CONFIRMAÇÃO
    // =========================================================

    const result = await Swal.fire({
      html: `
      <div class="swal-pdf-content">

        <div class="swal-pdf-question">
          ?
        </div>

        <div class="swal-pdf-heading">
          Gerar PDF?
        </div>

        <p class="swal-pdf-subtitle">
          Você está prestes a gerar um relatório com:
        </p>

        <div class="swal-pdf-count">
          ${enfermeirosPDF.length}
        </div>

        <div class="swal-pdf-label">
          enfermeiro(s)
        </div>

      </div>
    `,

      showCancelButton: true,

      confirmButtonText: "Sim, gerar",
      cancelButtonText: "Cancelar",

      reverseButtons: true,

      buttonsStyling: false,

      customClass: {
        popup: "swal-pdf-popup",
        htmlContainer: "swal-pdf-html",
        actions: "swal-pdf-actions",
        confirmButton: "swal-pdf-confirm",
        cancelButton: "swal-pdf-cancel",
      },
    });

    // =========================================================
    // CANCELOU
    // =========================================================

    if (!result.isConfirmed) {
      return;
    }

    // =========================================================
    // TOKEN
    // =========================================================

    const token = localStorage.getItem("id");

    if (!token) {
      Swal.fire({
        icon: "error",
        title: "Cliente não identificado",
        text: "Não foi possível identificar o cliente.",
        background: "#0f172a",
        color: "#fff",
        confirmButtonColor: "#ef4444",
      });

      return;
    }

    // =========================================================
    // ABRIR NOVA ABA
    // =========================================================

    const novaAba = window.open("", "_blank");

    if (!novaAba) {
      Swal.fire({
        icon: "warning",
        title: "Nova aba bloqueada",
        text: "Permita pop-ups para visualizar o relatório.",
        background: "#0f172a",
        color: "#fff",
        confirmButtonColor: "#f59e0b",
      });

      return;
    }

    // =========================================================
    // LOADING DENTRO DA NOVA ABA
    // =========================================================

    novaAba.document.write(`
    <!DOCTYPE html>

    <html lang="pt-BR">

    <head>

      <meta charset="UTF-8">

      <title>
        Gerando relatório...
      </title>

      <style>

        * {
          box-sizing: border-box;
        }

        html,
        body {
          margin: 0;
          width: 100%;
          height: 100%;

          font-family:
            Arial,
            Helvetica,
            sans-serif;

          background: #0b1220;
        }

        body {
          display: flex;

          align-items: center;
          justify-content: center;
        }

        .loading-container {

          width: 380px;

          padding: 42px 35px;

          text-align: center;

          border-radius: 18px;

          background:
            linear-gradient(
              145deg,
              #111c2d,
              #0d1726
            );

          border:
            1px solid
            rgba(255,255,255,.08);

          box-shadow:
            0 25px 70px
            rgba(0,0,0,.45);
        }

        .spinner {

          width: 48px;
          height: 48px;

          margin: 0 auto 25px;

          border-radius: 50%;

          border:
            3px solid
            rgba(255,255,255,.10);

          border-top-color:
            #0b73b5;

          animation:
            spin .8s linear infinite;
        }

        @keyframes spin {

          to {
            transform:
              rotate(360deg);
          }

        }

        .title {

          font-size: 20px;

          font-weight: 700;

          color: #ffffff;

          margin-bottom: 8px;
        }

        .text {

          font-size: 13px;

          color: #94a3b8;

          line-height: 1.5;
        }

        .brand {

          margin-top: 25px;

          font-size: 10px;

          color: #4d87ad;

          letter-spacing: 1.2px;

          text-transform: uppercase;
        }

      </style>

    </head>

    <body>

      <div class="loading-container">

        <div class="spinner"></div>

        <div class="title">
          Gerando relatório
        </div>

        <div class="text">
          Estamos preparando seu PDF.<br>
          Isso pode levar alguns segundos...
        </div>

        <div class="brand">
          Relatório de Enfermeiros
        </div>

      </div>

    </body>

    </html>
  `);

    novaAba.document.close();

    // =========================================================
    // FORM POST
    // =========================================================

    const form = novaAba.document.createElement("form");

    form.method = "POST";

    form.action =
      `${api.defaults.baseURL}/enfermeiroPDF`;

    form.style.display = "none";

    // =========================================================
    // TOKEN
    // =========================================================

    const inputToken =
      novaAba.document.createElement("input");

    inputToken.type = "hidden";

    inputToken.name = "token";

    inputToken.value = token;

    form.appendChild(inputToken);

    // =========================================================
    // ENFERMEIROS
    // =========================================================

    const inputEnfermeiros =
      novaAba.document.createElement("input");

    inputEnfermeiros.type = "hidden";

    inputEnfermeiros.name = "enfermeiros";

    inputEnfermeiros.value =
      JSON.stringify(enfermeirosPDF);

    form.appendChild(inputEnfermeiros);

    // =========================================================
    // QUANTIDADE
    // =========================================================

    const inputQuantidade =
      novaAba.document.createElement("input");

    inputQuantidade.type = "hidden";

    inputQuantidade.name = "quantidade";

    inputQuantidade.value =
      enfermeirosPDF.length;

    form.appendChild(inputQuantidade);

    // =========================================================
    // DEBUG
    // =========================================================

    console.log("=================================");
    console.log("POST /enfermeiroPDF");
    console.log("Token:", token);
    console.log("Quantidade:", enfermeirosPDF.length);
    console.log("Enfermeiros enviados:", enfermeirosPDF);
    console.log("JSON:", JSON.stringify(enfermeirosPDF));
    console.log("=================================");

    // =========================================================
    // ADICIONA FORM NA NOVA ABA
    // =========================================================

    novaAba.document.body.appendChild(form);

    // =========================================================
    // ENVIA
    // =========================================================

    form.submit();

    // =========================================================
    // LOADING NO SISTEMA
    // =========================================================

    Swal.fire({
      html: `
      <div class="swal-pdf-loading">

        <div class="swal-pdf-loading-spinner"></div>

        <div class="swal-pdf-loading-title">
          Gerando PDF
        </div>

        <div class="swal-pdf-loading-text">
          Preparando seu relatório...
        </div>

      </div>
    `,

      allowOutsideClick: false,
      allowEscapeKey: false,

      showConfirmButton: false,

      timer: 900,

      customClass: {
        popup: "swal-pdf-loading-popup",
        htmlContainer: "swal-pdf-loading-html",
      },
    });
  };

  const minDelay = 3000; // tempo mínimo elegante
  const limits = useCallback((e) => {
    const newLimit = parseInt(e.target.value, 10);

    setLoadingPage(true)
    setLimit(newLimit);
    setCurrentPage(1);
    setMediaPage(2);
  }, []);




  //===================================
  // LOADER PRINCIPAL
  //===================================

  async function fetchDataCache(limit, currentPage) {

    if (showLoader) {
      setLoading(true);
    }

    setLoadingPage(true);

    try {

      const { data } = await api.get(
        `/enfermeiropages?limit=${limit}&page=${currentPage}&searchTerm=${encodeURIComponent(searchTerm)}`,
        {
          headers: {
            typo: localStorage.getItem("id"),
          },
        }
      );

      setMarcadores(data?.enfermeiros?.data || []);

    } catch (error) {

      console.error(error);

      setMarcadores([]);

    } finally {

      setLoading(false);

      setShowLoader(false);

      setLoadingPage(false);
    }
  }

  //==================================
  //ITENS POR PAGINA
  //==================================
  useEffect(() => {
    let mounted = true;

    async function fetchData() {
      const start = Date.now();
      const MIN_DELAY = 2500; //2.5s = 2500ms

      try {
        const { data } = await api.get(`/enfermeiropages?limit=${limit}&page=${currentPage}&searchTerm=${searchTerm}`, {
          headers: {
            typo: localStorage.getItem("id"),
          },
        });

        if (mounted) {
          setMarcadores(data.enfermeiros.data || [])
        }

      } catch (error) {
        if (mounted) setMarcadores([])
      }

      finally {
        const elapsed = Date.now() - start;

        if (elapsed < MIN_DELAY) {
          await delay(MIN_DELAY - elapsed)
        }

        if (mounted) {
          setLoadingPage(false)
        }
      }
    }

    fetchData();
    return () => (mounted = false)
  }, [currentPage, limit, searchTerm]);









  //LOADDING PRINCIPAÇ
  useEffect(() => {
    if (currentPage >= 1) {
      fetchDataCache(limit, currentPage);
    }
  }, [currentPage, pages.length]);




  //EXIBINDO PAGINAÇÃO(NUMEROS)
  function getVisiblePages(currentPage, totalPages) {
    const pages = [];

    if (totalPages <= 3) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 2) {
        pages.push(1, 2, "...", totalPages);
      } else if (currentPage >= totalPages - 1) {
        pages.push(1, "...", totalPages - 1, totalPages);
      } else {
        pages.push(1, "...", currentPage, "...", totalPages);
      }
    }

    return pages;
  }

  // const setData = (marcador) => {
  //   let { id, nome, cpf, data_nascimento, multiple_checks } = marcador;
  //   localStorage.setItem("ID", id);
  //   localStorage.setItem("nome", nome);
  //   localStorage.setItem("cpf", cpf);
  //   localStorage.setItem("data_nascimento", data_nascimento);
  //   localStorage.setItem("multiple_checks", multiple_checks);
  // };




  //SELEÇÃO DE ITENS
  const handleSelect = (marcador) => {
    setSelectedItems((prev) => {
      const exists = prev.find((item) => item.id === marcador.id);
      if (exists) {
        return prev.filter((item) => item.id !== marcador.id);
      }
      return [...prev,
      {
        id: marcador.id,
        nome: marcador.nome,
        cpf: marcador.cpf,
        marcador_razao_social: marcador.razao_social
      }];
    });
  };












  //==================
  //EDITAR ENFERMEIRO
  //==================
  const handleEditar = async (marcador) => {
    const result = await Swal.fire({

      html: `
    <div class="swal-edicao-content">
      <div class="swal-edicao-question">
      ?
    </div>
      <div class="swal-edicao-heading">
      Editar Enfermeiro?
    </div>
      <p class="swal-edicao-subtitle">
        Confira os dados do enfermeiro antes de prosseguir com a edição.
      </p>

      <div class="swal-edicao-info">
        <div class="swal-info-row">
          <span>Nome:</span>
          <strong>${marcador?.nome || "-"}</strong>
        </div>

        <div class="swal-info-row">
          <span>CPF:</span>
          <strong>${marcador?.cpf || "-"}</strong>
        </div>

        <div class="swal-info-row">
          <span>Nome Fantasia:</span>
          <strong>${marcador?.razao_social || "-"}</strong>
        </div>
      </div>
    </div>
  `,
      showCancelButton: true,
      confirmButtonText: "Sim, editar",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
      buttonsStyling: false,
      customClass: {
        popup: "swal-edicao-popup",
        icon: "swal-edicao-icon",
        title: "swal-edicao-title",
        htmlContainer: "swal-edicao-html",
        actions: "swal-edicao-actions",
        confirmButton: "swal-edicao-confirm",
        cancelButton: "swal-edicao-cancel",
      },
    });

    if (!result.isConfirmed) return;

    await Swal.fire({
      title: "Abrindo edição",
      html: `
    <div class="swal-loading-content">
      <div class="swal-loading-spinner"></div>

      <div class="swal-loading-text">
        Preparando os dados do enfermeiro...
      </div>
    </div>
  `,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,

      customClass: {
        popup: "swal-loading-popup",
        title: "swal-loading-title",
        htmlContainer: "swal-loading-html",
      },

      didOpen: () => {
        setTimeout(() => {
          Swal.close();

          navigate("/maps/enfermeiro-up", {
            state: { marcador },
          });
        }, 700);
      },
    });
  };







  const handleSelectAll = () => {
    if (selectedItems.length === marcadores.length) {
      setSelectedItems([]);
    } else {
      setSelectedItems(
        marcadores.map((m) => ({ id: m.id, nome: m.nome, cpf: m.cpf, razao_social: m.razao_social }))
      );
    }
  };

  //EXCLUR SELECIONADOS (EXCLUIR.JS)
  const { excluirSelecionados } = useExcluirEnfermeiros({
    searchTerm,
    limit,
    currentPage,
    fetchDataCache,
    setTotalItems,
  });

  return (
    <>
      <ToastContainer />

      <div className="enfermeiros-page" style={{ paddingTop: 0, minHeight: 0 }}>
        <section className="enfermeiros-panel">
          <Preloader
            show={loading}
            text="Carregando dados dos enfermeiros..."
            customClass="laoder-enfermeiro"
          />
         
         <img src={logo} alt="Logo INOVA" className="logo"/>

          {/* Cabeçalho no mesmo padrão da Manutenção */}
          <header className="enfermeiros-ui-header">
            <div className="enfermeiros-ui-heading">
              <span className="enfermeiros-ui-heading-icon">
                <FiUserPlus size={18} />
              </span>

              <div className="enfermeiros-ui-heading-text">
                <h1 className="enfermeiros-ui-title">Enfermeiros</h1>
                <p className="enfermeiros-ui-subtitle">
                  Gerencie os enfermeiros cadastrados e seus acessos
                </p>
              </div>
            </div>

            <button
              type="button"
              className="enfermeiros-ui-close"
              onClick={() => navigate(-1)}
              aria-label="Fechar enfermeiros"
              title="Fechar"
            >
              <FiX size={21} />
            </button>
          </header>

          {/* Pesquisa e ações */}
          <div className="enfermeiros-ui-toolbar">
            <label className="enfermeiros-ui-search" htmlFor="enfermeiro-search">
              <FiSearch size={17} aria-hidden="true" />

              <input
                id="enfermeiro-search"
                type="search"
                placeholder="Buscar enfermeiro, CPF ou nome fantasia..."
                value={searchTerm}
                onChange={(event) => setSearchTerm(event.target.value)}
                autoComplete="off"
                aria-label="Buscar enfermeiros"
              />

              {searchTerm && (
                <button
                  type="button"
                  className="enfermeiros-ui-search-clear"
                  onClick={() => setSearchTerm("")}
                  aria-label="Limpar pesquisa"
                  title="Limpar pesquisa"
                >
                  <FiX size={15} />
                </button>
              )}
            </label>

            {isAdminState && (
              <div className="enfermeiro-toolbar-actions">
                <button
                  type="button"
                  onClick={confirmarPDF}
                  className="enfermeiro-btn-pdf"
                >
                  <FiFileText size={16} />
                  <span>Gerar PDF</span>
                </button>

                <Link
                  to="/maps/enfermeiro-up"
                  state={{ modo: "cadastro" }}
                  className="enfermeiros-ui-btn-novo"
                >
                  <FiPlus size={17} />
                  <span>Novo Enfermeiro</span>
                </Link>
              </div>
            )}
          </div>

          {/* Tabela */}
          <div className="enfermeiros-ui-table-area">
          
            
            <div className="enfermeiros-ui-table-scroll enfermeiros-table-scroll">
              <table className="enfermeiros-ui-table enfermeiros-table">
                <thead>
                  <tr>
                    <th scope="col">Nome</th>
                    <th scope="col" className="enfermeiro-cell-center">CPF</th>
                    <th scope="col">Nome fantasia</th>
                    <th scope="col" className="enfermeiro-cell-center">
                      Múltiplos acessos
                    </th>
                    {isAdminState && (
                      <th scope="col" className="enfermeiro-cell-center">
                        <label className="enfermeiro-select-checkbox" title="Selecionar todos">
                          <input
                            type="checkbox"
                            onChange={handleSelectAll}
                            checked={
                              marcadores.length > 0 &&
                              selectedItems.length === marcadores.length
                            }
                            ref={(input) => {
                              if (input) {
                                input.indeterminate =
                                  selectedItems.length > 0 &&
                                  selectedItems.length < marcadores.length;
                              }
                            }}
                            aria-label="Selecionar todos os enfermeiros desta página"
                          />
                          <span />
                        </label>
                      </th>
                    )}
                  </tr>
                </thead>

                <tbody>
                  {marcadores.map((marcador) => (
                    <tr key={marcador.id}>
                      <td>
                        <span className="enfermeiro-nome">
                          {String(marcador.nome || "—").toUpperCase()}
                        </span>
                      </td>

                      <td className="enfermeiro-cell-center">
                        {marcador.cpf || "—"}
                      </td>

                      <td>{marcador.razao_social || "—"}</td>

                      <td className="enfermeiro-cell-center">
                        <span
                          className={`enfermeiro-access-status ${
                            marcador.multiple_checks === true ? "is-enabled" : "is-disabled"
                          }`}
                        >
                          {marcador.multiple_checks === true ? "Sim" : "Não"}
                        </span>
                      </td>

                      {isAdminState && (
                        <td className="enfermeiro-cell-center">
                          <div className="enfermeiro-row-actions">
                            <Tooltip title="Editar enfermeiro" arrow placement="bottom">
                              <button
                                type="button"
                                className="enfermeiro-edit-btn"
                                onClick={() => handleEditar(marcador)}
                                aria-label={`Editar ${marcador.nome || "enfermeiro"}`}
                              >
                                <CiEdit size={22} />
                              </button>
                            </Tooltip>

                            <label className="enfermeiro-select-checkbox" title="Selecionar enfermeiro">
                              <input
                                type="checkbox"
                                checked={selectedItems.some((item) => item.id === marcador.id)}
                                onChange={() => handleSelect(marcador)}
                                aria-label={`Selecionar ${marcador.nome || "enfermeiro"}`}
                              />
                              <span />
                            </label>
                          </div>
                        </td>
                      )}
                    </tr>
                  ))}

                  {!loadingPage && marcadores.length === 0 && (
                    <tr>
                      <td colSpan={isAdminState ? 5 : 4}>
                        <div className="enfermeiros-ui-empty-state">
                          <FiUserPlus size={25} />
                          <strong>
                            {searchTerm.trim()
                              ? "Nenhum resultado encontrado"
                              : "Nenhum enfermeiro cadastrado"}
                          </strong>
                          <span>
                            {searchTerm.trim()
                              ? "Tente outro termo ou limpe a pesquisa."
                              : "Quando houver enfermeiros cadastrados, eles aparecerão aqui."}
                          </span>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Seleção em massa */}
          {isAdminState && selectedItems.length > 0 && (
            <div className="enfermeiro-bulk-actions">
              <span>
                {selectedItems.length}{" "}
                {selectedItems.length === 1 ? "enfermeiro selecionado" : "enfermeiros selecionados"}
              </span>

              <Tooltip title="Excluir selecionados" arrow placement="top">
                <button
                  type="button"
                  className="enfermeiro-delete-selected"
                  onClick={() => excluirSelecionados(selectedItems, setSelectedItems)}
                >
                  <MdDeleteForever size={19} />
                  <span>Excluir selecionados</span>
                </button>
              </Tooltip>
            </div>
          )}

          {/* Rodapé no mesmo padrão da Manutenção */}
          <footer className="enfermeiros-ui-footer">
            <div className="enfermeiros-ui-total">
              <span>
                <strong>{totalItems}</strong>{" "}
                {totalItems === 1 ? "enfermeiro" : "enfermeiros"}
              </span>

              <span className="enfermeiros-ui-total-separator" />

              <span>
                Página{" "}
                <strong>{pages.length ? currentPage : 0}</strong>{" "}
                de <strong>{pages.length}</strong>
              </span>
            </div>

            <nav className="enfermeiros-ui-pagination" aria-label="Paginação dos enfermeiros">
              <button
                type="button"
                className="enfermeiros-ui-page-btn"
                onClick={() => handlePagination(currentPage - 1)}
                disabled={currentPage <= 1 || loadingPage}
                aria-label="Página anterior"
              >
                <FiChevronLeft size={15} />
              </button>

              {getVisiblePages(currentPage, pages.length).map((page, index) => (
                <React.Fragment key={`${page}-${index}`}>
                  {page === "..." ? (
                    <span className="enfermeiros-ui-page-dots">…</span>
                  ) : (
                    <button
                      type="button"
                      className={`enfermeiros-ui-page-btn ${
                        page === currentPage ? "active" : ""
                      }`}
                      onClick={() => handlePagination(page)}
                      disabled={loadingPage}
                      aria-current={page === currentPage ? "page" : undefined}
                    >
                      {page}
                    </button>
                  )}
                </React.Fragment>
              ))}

              <button
                type="button"
                className="enfermeiros-ui-page-btn"
                onClick={() => handlePagination(currentPage + 1)}
                disabled={currentPage >= pages.length || loadingPage}
                aria-label="Próxima página"
              >
                <FiChevronRight size={15} />
              </button>
            </nav>

            <label className="enfermeiros-ui-limit">
              <span>Exibir</span>

              <select
                value={limit}
                onChange={limits}
                aria-label="Quantidade de enfermeiros por página"
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                {totalItems > 0 && (
                  <option value={totalItems}>Todos ({totalItems})</option>
                )}
              </select>

              <span>por página</span>
            </label>
          </footer>
        </section>
      </div>
    </>
  );
}

export default Enfermeiros;
